import { styled } from '@mui/material/styles';
import { Accordion, AccordionSummary, Stack } from '@mui/material';

export const StyledAccordion = styled(Accordion)(({ theme }) => ({
  boxShadow: 'none',
  backgroundColor: theme.palette.grey[100],
  '&.MuiPaper-root': {
    borderRadius: theme.shape.borderRadius,
    '&:before': {
      backgroundColor: 'transparent',
    },
  },
}));

export const StyledAccordionSummary = styled(AccordionSummary)({
  '&.MuiAccordionSummary-root': {
    margin: 0,
    minHeight: 36,
    '.MuiAccordionSummary-content': {
      margin: 0,
    },
  },
});

export const LogContainer = styled(Stack)(({ theme }) => ({
  width: '100%',
  // maxWidth: 600,
  minWidth: 100,
  borderRadius: '16px',
  border: `1px solid ${theme.palette.divider}`,
  display: 'flex',
  flexDirection: 'column',
  position: 'relative',
  justifyContent: 'flex-end',
}));

export const LogHeader = styled(Stack)(({ theme }) => ({
  display: 'flex',
  padding: theme.spacing(1, 2),
  flexDirection: 'row',
  borderRadius: '16px 16px 0 0',
  alignItems: 'center',
  gap: theme.spacing(1),
  backgroundColor: theme.palette.grey[300],
}));

export const LogContent = styled(Stack)(({ theme }) => ({
  gap: theme.spacing(1),
  borderRadius: '0 0 16px 16px',
  backgroundColor: theme.palette.background.paper,
  padding: theme.spacing(2),
}));
